import { useContext } from 'react'

import context from './context'

export const useModal = () => useContext(context)
